import React, { Component } from "react";
import { Link } from 'react-router';
import GA from 'lib/ga';
import {connect} from "react-redux";
import { rootUrl, imageUrl, appUrl } from 'helpers/ApplicationHelper';
import I18n from "lib/i18n/i18n";
import Menu, { SubMenu, Item as MenuItem } from 'rc-menu';
import {tabs as menuItems} from '../constants/menu';
import {Drawer} from "@worthy-npm/clarity";

class MenuBar extends Component {
    constructor(props){
        super(props);

        this.state = {
            mobileMenuVisible: false,
            isLoaded: false
        };

        this.isLoggedIn = this.isLoggedIn.bind(this);
        this.isCurrentPage = this.isCurrentPage.bind(this);
        this.renderSubLinks = this.renderSubLinks.bind(this);
    }

    componentDidMount() {
        this.setState({isLoaded: true});
    }

    isLoggedIn(){
        return this.props.Session && this.props.Session.isLoggedIn;
    }

    isCurrentPage(item){
        return this.state.isLoaded && (window.location.pathname === item.rootLink || window.location.pathname === item.link);
    }

    linkTo(item){
        return item.rootLink ? rootUrl(item.rootLink) : appUrl(item.link);
    }

    openNewTab(link){
        return link.includes('blog');
    }

    renderSubLinks(subItems, user) {
        const userData = {
            userId: user && user.id,
            leadId: user && user.lead_id
        }

        let linksComponent = subItems.map((link, i) => {
            let rootLink = null;
            let url = this.linkTo(link);
            if( user && link.rootLink && link.rootLink.includes('{') ){
                rootLink = link.rootLink
                for( let k in userData ){
                    rootLink  = rootLink.replace(`{${k}}`, userData[k]);
                }
                url = rootLink;
            }
            return <MenuItem className={'sub-list-item'} key={i}>
                <Link
                    key={i}
                    to={url}
                    className="link "
                    target={this.openNewTab(url) ? '_blank' : '_self'}
                    onClick={()=>GA.headerLinkClicked(link.title)}
                >
                    { link.imageUrl ? <img className={'sub-menu-icon'} src={imageUrl(link.imageUrl)} /> : null }
                    { link.title }
                </Link>
            </MenuItem>;
        });
        return linksComponent;
    }

    seeMyItems() {
        try {
            UserActions.drawerClick()
        } finally {
            window.location =  appUrl(`/items`)
        }
    }

    render() {
        const user = this.props.ADO && this.props.ADO.user;
        const userName = user && user.first_name || '';
        const leftItems = menuItems.baseItems;
        const rightItems = menuItems.signInItems[this.isLoggedIn() ? 'loggedIn' : 'signIn'];

        let leftMenu = leftItems.filter(i => i.desktop !== false ).map((item, i) => {
            let url = this.linkTo(item);
            let link = <Link key={i}
                             to={ url }
                             className={`left ${this.isCurrentPage(item) ? 'current' : ''}`}
                             target={this.openNewTab(url) ? '_blank' : '_self'}
                             onClick={()=>GA.headerLinkClicked(item.title)}
            >
                { item.title }
            </Link>
            return <MenuItem className={`left`} key={i} >{link}</MenuItem>;
        });

        let rightMenu = this.isLoggedIn() ?
                <SubMenu className={'right'}
                         popupClassName={'sub-popup'}
                         title={<Link to={rightItems.link}>{I18n.getString('header::menu::titles::hi', {userName})}</Link>} >
                    { this.renderSubLinks(rightItems.subItems, user) }
                </SubMenu>
            : <MenuItem className={"signin right"}>{<Link to={rightItems.link}>{rightItems.title}</Link>}</MenuItem>;

        return (
            <div>
                <Menu
                    className='main-wrapper'
                    mode="horizontal"
                    openAnimation="slide-up" >
                    { leftMenu }
                    {
                        this.isLoggedIn() ?
                            <MenuItem className={'right icon drawer'}><Drawer alertsNum={this.props.itemsCount} onClick={()=>this.seeMyItems()}/></MenuItem>
                            : null
                    }
                    { rightMenu }
                </Menu>
            </div>
        );
    }
}

const mapStateToProps = ({Session, ADO, ItemsCount}) => {
    return {
        Session,
        ADO,
        itemsCount: ItemsCount,
    }
};

export default connect(mapStateToProps)(MenuBar);
